import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useLogin } from '../../hooks/useLogin';

function EmailConfirmSuccess() {
    const { token } = useParams();
    const { confirmEmail, error, success } = useLogin();

    useEffect(() => {
        confirmEmail(token);
    }, [token, confirmEmail]);

    return (
        <div className="pageContainer">
            {error && (
                <p>{error}</p>
            )}
            {success && (
                <div>
                    <h1>Erfolgreich!</h1>
                    <p>Deine E-Mail-Adresse wurde erfolgreich bestätigt.</p>
                    <Link to="/login">Zurück zur Anmeldung</Link>
                </div>
            )}
        </div>
    );
}

export default EmailConfirmSuccess;